/* @flow */

import * as React from 'react';
import glamorous from 'glamorous';

type ValueType = boolean | number | string;

type Props = {
  children: React.ChildrenArray<*>,
  onSelect: ValueType => void,
  selectedValue?: ValueType,
};

const defaultProps = {
  selectedValue: undefined,
};

const GridSelectList = glamorous.ul({
  display: 'flex',
  flexWrap: 'wrap',
  listStyle: 'none',
  margin: 0,
  padding: 0,
});

const GridSelectOption = glamorous.li({
  flexBasis: '50%',
  flexGrow: 0,
  flexShrink: 0,
});

function GridSelect({
  children,
  onSelect,
  selectedValue,
}: Props) {
  return (
    <GridSelectList>
      {React.Children.map(children, child => (
        <GridSelectOption>
          {React.cloneElement(child, {
            onSelect,
            selectedValue,
          })}
        </GridSelectOption>
      ))}
    </GridSelectList>
  );
}

GridSelect.defaultProps = defaultProps;

export default GridSelect;
